import { graphql, useStaticQuery } from 'gatsby';

import { CollectionData, Language } from '@mewa/types';

import { ProductCardBaseData } from '../../../../components/slider/product-card-base';

export const useCollection = (
  collectionUuid: string,
  lang: Language,
  locale: string,
) => {
  const { allPimCollection, allTranslation } = useStaticQuery<{
    allPimCollection: {
      nodes: (Pick<CollectionData, 'assets' | 'claim' | 'name'> & {
        uuid: string;
        slug: string;
        lang: string;
        products: ProductCardBaseData[];
      })[];
    };
    allTranslation: {
      nodes: {
        collection_slider_collection_link_label: string;
        show_product_details_label: string;
        locale: string;
      }[];
    };
  }>(graphql`
    query {
      allPimCollection {
        nodes {
          uuid
          slug
          lang
          name
          claim
          assets {
            keyVisualDesktop
            keyVisualMobile
            emotion
          }
          products {
            displayName
            modelName
            slug
            keyFacts

            variants {
              name
              slug
              hash
              colorName
              assetId
            }

            serviceSegment {
              slug
              key
            }
          }
        }
      }

      allTranslation {
        nodes {
          locale
          collection_slider_collection_link_label
          show_product_details_label
        }
      }
    }
  `);

  const collection = allPimCollection.nodes.find(
    (collection) =>
      collection.uuid === collectionUuid && collection.lang === lang,
  );
  const translations = allTranslation.nodes.find(
    (translations) => translations.locale === locale,
  );

  return { collection, translations };
};
